<template>
  <div
    class="text-white rounded p-1 line-height-10 d-flex align-items-center"
    :class="classes"
  >
    <slot>
      <i :class="iconClasses"></i>
      <small class="font-weight-bold mx-1">{{ displayedText }}</small>
    </slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type:String,
      required: true,
    },
    text: String,
  },

  computed: {
    /**
     * @return {Array}
     */
    classes() {
      return ['bg-gray-600'];
    },

    /**
     * @return {*}
     */
    iconClasses () {
      const map = {
        email: ['fas fa-at'],
        sms: ['far fa-comment-alt'],
        draft: ['far fa-file-alt'],
        queued: ['fas fa-play-circle'],
        scheduled: ['far fa-clock text-warning'],
        sent: ['fas fa-check-circle'],
        error: ['fas fa-times-circle'],
        canceled: ['fas fa-ban'],
      };

      return _.get(map, this.type, ['fas fa-info-circle']);
    },

    /**
     * @return {string}
     */
    displayedText() {
      return this.text || _.upperCase(this.type) ;
    },
  }
}
</script>
